import { VendorListUrlSortField } from "@dashboard/vendors/urls";
import { UserSortField } from "@dashboard/graphql";
import { createGetSortQueryVariables } from "@dashboard/utils/sort";

export function getSortQueryField(sort: VendorListUrlSortField): UserSortField | undefined {
  switch (sort) {
    case VendorListUrlSortField.email:
      return UserSortField.EMAIL;
    case VendorListUrlSortField.name:
      return UserSortField.LAST_NAME;
    case VendorListUrlSortField.orders:
      return UserSortField.ORDER_COUNT;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(getSortQueryField);